export default {
  // 图例标签
  basic: "基础",
  behavior: "行为",
  entity: "实体",
  clue: "线索",
  maliciousBlack: "恶意黑",
  maliciousGray: "恶意灰",
  transaction: "交易",
};
